var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    stroke: "#F2BA4C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.667 5H8.333A3.333 3.333 0 005 8.333v23.334A3.333 3.333 0 008.333 35h23.334A3.333 3.333 0 0035 31.667V8.333A3.333 3.333 0 0031.667 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 16.667a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM35 25l-8.333-8.333L8.334 35"
  }))));
}
export default SvgEmptyImage;